<ng-container
    *ngIf="cameFromFlWinning == false"
    `
>
    <div
        class="cmps-cdk-d-flex fl-winning cmps-cdk-justify-content-space-between cmps-cdk-mb-1"
    >
        <div
            class="cmps-cdk-flex-20 cmps-cdk-d-flex cmps-cdk-pr-1 align-items-center"
        >
            <div class="cmps-cdk-mr-0dot75 fl-winning-label">
                {{ _i18n._709_DATE_RANGE___ | translate }}
            </div>
            <div class="cmps-cdk-pos-relative w-75">
                <select
                    class="fl-winning-main--select w-100"
                    (change)="_onDataRangeChange($event)"
                >
                    <ng-container *ngFor="let i of state?.dataRanges">
                        <option
                            [value]="i.dataRangeId"
                            [selected]="
                                i.dataRangeId === state?.selectedDataRangeId
                            "
                        >
                            {{ i.dataRangeName }}
                        </option>
                    </ng-container>
                </select>
                <div
                    class="cmps-cdk-pos-absolute cmps-cdk-pos-top-n0dot75 cmps-cdk-pos-right-n0dot75"
                    [cmpsTooltipTrigger]="
                        _i18n._10081_DATE_RANGE_IS_THAT___ | translate
                    "
                >
                    <cmps-icon svgIcon="information"></cmps-icon>
                </div>
            </div>
        </div>

        <div
            class="cmps-cdk-flex-20 cmps-cdk-d-flex cmps-cdk-px-1 align-items-center"
        >
            <div class="cmps-cdk-mr-0dot75 fl-winning-label">
                {{ _i18n._10082_EVALUATION_RANGE___ | translate }}
            </div>
            <div class="cmps-cdk-pos-relative w-100">
                <select
                    class="fl-winning-main--select w-100"
                    (change)="_onEvalRangeChange($event)"
                >
                    <ng-container *ngFor="let i of state?.evalRanges">
                        <option
                            [value]="i.evaluationRangeId"
                            [selected]="
                                i.evaluationRangeId ===
                                state?.selectedEvalRangeId
                            "
                        >
                            {{ i.evaluationRangeName }}
                        </option>
                    </ng-container>
                </select>
                <div
                    class="cmps-cdk-pos-absolute cmps-cdk-pos-top-n0dot75 cmps-cdk-pos-right-n0dot75"
                    [cmpsTooltipTrigger]="
                        _i18n._10083_THE_EVALUATION_RANGE_IS___ | translate
                    "
                >
                    <cmps-icon svgIcon="information"></cmps-icon>
                </div>
            </div>
        </div>

        <div class="cmps-cdk-flex-20 cmps-cdk-px-1 pt-2">
            <ng-container *ngIf="flWinningPersonData?.hasData">
                <span class="cmps-cdk-text-bold cmps-cdk-mr-0dot5">{{
                    _i18n._10084_SELECTED_PERIOD___ | translate
                }}</span>
                <span
                    >{{
                        flWinningPersonData?.userDates[0]?.startDateDataRange
                            | cmpsDate: 'MMM d, y'
                    }}&nbsp;-&nbsp;{{
                        flWinningPersonData?.userDates[0]?.endDateDataRange
                            | cmpsDate: 'MMM d, y'
                    }}</span
                >
            </ng-container>
        </div>

        <div class="cmps-cdk-flex-15 cmps-cdk-px-1 pt-2">
            <ng-container *ngIf="flWinningPersonData?.hasData">
                <span class="cmps-cdk-text-bold cmps-cdk-mr-0dot5">{{
                    _i18n._7313_LAST_UPDATE___ | translate
                }}</span>
                <span>{{
                    flWinningPersonData?.userDates[0]?.createdOn
                        | cmpsDate: 'MMM d, y, h:mm a'
                }}</span>
            </ng-container>
        </div>
    </div>
</ng-container>
<div>
    <div>
        <ng-container *ngIf="flWinningPersonData?.hasData == false">
            <div class="table-coaching-insight-content-sec">
                <div class="text-center">
                    {{ _i18n._11146_No_FRONT_LINE_WINNING_DATA___ | translate }}
                </div>
            </div>
        </ng-container>
        <cmps-frontline-winning
            *ngIf="isGridFilled == true"
            [OnFLPersonChange]="flPersonchange"
            [selectedUser]="selecteduser"
            (selectedUserChange)="handleCurrentViewChange($event)"
        >
        </cmps-frontline-winning>
    </div>
    <div class="row wp-population">
        <div class="col-12">
            <button
                *ngIf="cameFromFlWinning == true"
                (click)="goBackToStoredFavourite()"
                class="btn legend-button"
            >
                <cmps-icon svgIcon="reply"></cmps-icon>
                <span>{{
                    _i18n._7495_BACK_TO_PREVIOUS_VIEW___ | translate
                }}</span>
            </button>
            <cmps-coaching-wp-main
                *ngIf="cameFromFlWinning == true"
                [userId]="tlUserId"
            >
            </cmps-coaching-wp-main>
        </div>
    </div>
</div>
